import { ISearchElementStyle } from './searchPageConfig';

// Consumer-side mirror of the admin editor's checkout page config
// (ac-main/web: components/Storefront/Editor/checkoutPageConfig.ts). Persisted as a single JSON
// string on IStorefrontSettings.checkoutPageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the checkout (order) page via elementStyleFrom. Absent config = zero
// inline styles (the page renders exactly as before), so this is strictly additive.
export interface ICheckoutPageConfig {
    // The page's main content wrapper (max-width column).
    container?: ISearchElementStyle;
    // The "Order Summary" page heading.
    title?: ISearchElementStyle;
    // The order summary box that wraps the totals table (the pod on the right).
    summaryBox?: ISearchElementStyle;
    // The container wrapping the shipping / billing / terms-and-conditions form column.
    formContainer?: ISearchElementStyle;
    // The final "Total" row of the order totals table.
    totalRow?: ISearchElementStyle;
    // The form section headings ("Shipping Information" / "Billing Information").
    sectionHeading?: ISearchElementStyle;
    // The primary "Place Order" call-to-action button.
    placeOrderButton?: ISearchElementStyle;
    // The prerequisites (checkout questions) box on the prerequisites page.
    prerequisitesBox?: ISearchElementStyle;
    // The "Continue to Checkout" button on the prerequisites page.
    continueButton?: ISearchElementStyle;
}

export const CHECKOUT_PAGE_SECTIONS = [
    'container', 'title', 'summaryBox', 'formContainer', 'totalRow', 'sectionHeading',
    'placeOrderButton', 'prerequisitesBox', 'continueButton',
] as const;

export const DEFAULT_CHECKOUT_PAGE_CONFIG: ICheckoutPageConfig = {};

export function parseCheckoutPageConfig(raw?: string): ICheckoutPageConfig {
    if (!raw) return { ...DEFAULT_CHECKOUT_PAGE_CONFIG };
    try {
        return { ...DEFAULT_CHECKOUT_PAGE_CONFIG, ...(JSON.parse(raw) as ICheckoutPageConfig) };
    } catch {
        return { ...DEFAULT_CHECKOUT_PAGE_CONFIG };
    }
}
